// @flow

// Utils
import traverse from 'fc-utils/traverse'

// Constants
import {
  TREE,
  REPORTS_ERRORS,
} from '../constants'

export default traverse([TREE, REPORTS_ERRORS], {default: {}})
